// Segement's analytics.js isn't webpack friendly...

const track = (eventName, props) =>
  new Promise(resolve => {
    const analytics = window.analytics;
    if (analytics) {
      analytics.track(eventName, props, {}, () => resolve());
    } else {
      if (process.env.NODE_ENV === 'development') {
        const propsSuffix = props ? `, props: ${JSON.stringify(props)}` : '';
        console.log(`Segment event: ${eventName}${propsSuffix}`);
      }
      resolve();
    }
  });

export default track;
